import {type JSX, useEffect, useState} from "react";
import {Navigate} from "react-router-dom";
import {checkAdminAuth} from "../api/auth";

const ProtectedRoute = ({children}: { children: JSX.Element }) => {
    const [isLoading, setIsLoading] = useState(true);
    const [isAuthorized, setIsAuthorized] = useState(false);

    useEffect(() => {
        const checkAuth = async () => {
            try {
                const authorized = await checkAdminAuth();
                setIsAuthorized(authorized);
            } catch {
                setIsAuthorized(false);
            } finally {
                setIsLoading(false);
            }
        };

        checkAuth();
    }, []);

    if (isLoading) return <div>Loading...</div>;
    if (!isAuthorized) return <Navigate to="/admin" replace/>;

    return children;
};

export default ProtectedRoute;